import React, { Dispatch, SetStateAction } from "react";
import { WpCategory, WpPage, WpPost, WpProject_Gallery, WpProject_Gallery_Category } from "codegen";
import { FilterDropdown } from "./FilterDropdown";
import { FilterSearch } from "./FilterSearch";
import { FilterTags } from "./FilterTags";

interface FilterProps {
  filterType: "dropdown" | "searchBar" | "tags";
  dropdownItems?: (WpCategory | WpProject_Gallery_Category)[] & any; // Account for Intrinsic Types
  contentToSearch: (WpPost | WpPage | WpProject_Gallery)[] & any; //Account for Intrinsic Types
  setSearchResults:
    | Dispatch<SetStateAction<WpPost[]>>
    | Dispatch<SetStateAction<WpPage[]>>
    | Dispatch<SetStateAction<WpProject_Gallery[]>>;
  placeholderText?: string;
  defaultItem?: WpCategory;
  categories?: (WpCategory | WpProject_Gallery_Category)[] & any; // Account for Intrinsic Types
  categoryPage?: boolean;
}

/**
 * Component that will search through any set of posts or pages that are passed down
 *
 * @param filterType - "dropdown" | "searchBar" - different ways for filter to be displayed
 * @param categories - Items to be displays within the dropdown, would be a post category
 * @param contentToSearch - Content to search
 * @param placeholderText - Default "Search...". Insert if the inputs should display an alternative
 * @param setSearchResults - Sets search results
 * @param postType - The different type of posts, eg /blog/ or /projects/
 * @returns Search functionality through posts or pages that are passed down
 *
 */
export const Filter = ({
  filterType,
  categories = [],
  contentToSearch = [],
  placeholderText = "Search...",
  setSearchResults,
  categoryPage = false,
}: FilterProps): JSX.Element => {
  switch (filterType) {
    case "dropdown":
      return <FilterDropdown categories={categories} />;

    case "searchBar":
      return (
        <FilterSearch
          contentToSearch={contentToSearch}
          placeholderText={placeholderText}
          setSearchResults={setSearchResults}
        />
      );

    case "tags":
      return <FilterTags categories={categories} categoryPage={categoryPage} />;

    default:
      return <p>This filter type is not supported</p>;
  }
};
